<template>
    <div class="checkbox">
        <input
            :id="id"
            :checked="value"
            @input="$emit('input', $event.target.checked)"
            type="checkbox"
            class="checkbox__input"
        />
        <label :for="id" class="checkbox__label"
            ><span class="checkbox__text">{{ label }}</span></label
        >
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [String, Number],
            required: true
        },
        label: {
            type: String
        },
        value: {
            type: [Boolean, Number],
            default: false
        }
    }
};
</script>

<style lang="scss">
.checkbox {
    position: relative;
    display: flex;
    align-items: center;
    // .checkbox__input
    &__input {
        position: absolute;
        width: 0;
        height: 0;
        opacity: 0;
        &:focus + .checkbox__label:before {
            // box-shadow: 0 0 5px #000;
        }
        &:checked + .checkbox__label:before {
            background: #0180ff;
        }
    }
    // .checkbox__label
    &__label {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        position: relative;
        gap: 16px;
        &:before {
            content: "";
            align-self: flex-start;
            flex: 0 0 20px;
            width: 20px;
            height: 20px;
            border-radius: 5px;
            border: 1px solid #263238;
        }
    }
    // .checkbox__text
    &__text {
        color: #000;
        font-family: "Montserrat";
        font-size: 15px;
        font-weight: 700;
        line-height: normal;
    }
}
</style>
